<script>
// Lucide icon (message-square-warning) — ISC. Ported as a local SVG: the ERP is Vue 2 and
// cannot take a new dependency (node_modules is a shared symlink).
// Standard: GREENN-ENG-DOC/front-end/design-system/icons.md
export default {
  name: 'MessageSquareWarningIcon',
  props: {
    color: {
      type: String,
      default: 'currentColor',
    },
    size: {
      type: [Number, String],
      default: 18,
    },
  },
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    :stroke="color"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
    <path d="M12 15h.01" />
    <path d="M12 7v4" />
  </svg>
</template>
